define('collections/adminCreativeComponents',["Underscore", "T1", "T1Collection", "models/adminCreativeComponent"], function (_, T1, T1Collection, AdminCreativeComponent) {
  "use strict";

  T1.Models.AdminCreativeComponents = T1Collection.extend({
    apiRoot: COMPASS_ENV.COMPONENT_API_BASE,
    urlString: "components",
    model: AdminCreativeComponent,
    isPaginated: false,
    fetchOptions: {},
    fetchCount: 0,
    page: 0,
    moreFetchable: false,
    fetch: function (options) {
      var self = this;
      var onSuccess;
      if (!options || !options.add) {
        this.unregister();
        this.page = 0;
      }
      options = options || {};
      onSuccess = function (data) {
        self.loaded = true;
        self.count = data.meta.total_count;
        self[options.add ? "add" : "reset"](data.data);
        if (options.success) {
          options.success(data);
        }
        return self;
      };
      self.loaded = false;
      var syncOpts = {
        action: self.action,
        dataType: "json",
        success: onSuccess,
        processAjaxResponse: function (data) {
          return {
            statusCode: "ok",
            jsonData: data
          };
        }
      };
      if (options.url) {
        syncOpts.params = options.url;
      }
      self.ajx = self.sync("read", "", syncOpts);
      if (self.ajx) {
        self.ajx.always(function () {
          self.ajx = null;
        });
      }
      return self.ajx;
    },
    filterBy: function (key, value, onsuccess) {
      var self = this;
      var opts = {};
      if (onsuccess) {
        opts = {
          success: onsuccess
        };
      }
      self.page = 0;
      if (key === "search" && value.length) {
        this.fetchOptions.search = value;
      }
      if (key === "status") {
        if (value >= 0 && value < 2) {
          this.fetchOptions.status = value;
        } else {
          delete this.fetchOptions.status;
        }
      }
      this.loaded = false;
      this.trigger("startSearch");
      return self.fetch(opts);
    },
    initialize: function () {
      T1Collection.prototype.initialize.apply(this, arguments);
    }
  });
  return T1.Models.AdminCreativeComponents;
});
